module.exports = __webpack_public_path__ + "static/media/subscribeGuide1_Jap.41691957.png";